import React, {Component} from "react";
import DefaultModal from "../invoice/DefaultModal";
import {Col, Row} from "reactstrap";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import axios from "axios";
import Alert from "react-s-alert";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";

import Datetime from "react-datetime";
import moment from "moment";


class copyModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            realIndex: 0,
            documentList: [],
            index: 0,
            issueDateTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
            openDate: false,
            padding:null,
            sendBtnDisabled:false

        };
        this.onCancel = this.onCancel.bind(this);
        this.copy = this.copy.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.isValidDate = this.isValidDate.bind(this);
        this.onChangeValueTotal = this.onChangeValueTotal.bind(this);
        this.defineStyleForChangeDateTimeForAll = this.defineStyleForChangeDateTimeForAll.bind(this);
    };

    onCancel() {
        if (this._source)
            this._source.cancel();

        if (this.state.index > 0) {
            this.props.toggleModal(false, true);
        } else {
            this.props.toggleModal(false, false);
        }
        this.setState({openDate: false, documentList: null});
    }

    componentDidMount() {
        let self = this;
        let params = {
            url: `/${self.props.controlType}/eliminationDocument`,
            method: 'post',
            data: {
                documentUuids: self.props.documentUuids
            }
        };
        request(params)
            .then(function (response) {
                let documentList = response.data;
                self.setState({
                    documentList: documentList,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });

        this.defineStyleForChangeDateTimeForAll();
    }

    onChangeValue(e, document, index) {
        let self = this;
        let value = e.target.value;
        let datetime = moment(value).format("YYYY-MM-DDTHH:mm:ss");
        let documentList = self.state.documentList;
        document.issuesDate = datetime;
        documentList[index] = document;
        self.setState({documentList});
    }

    onChangeValueTotal(e) {
        let value = e.target.value;
        let datetime = moment(value).format("YYYY-MM-DDTHH:mm:ss");
        let documentList = this.state.documentList;
        for (let i = 0; i < documentList.length; i++) {
            documentList[i].issuesDate = datetime;
        }
        this.setState({documentList, issueDateTime: datetime});
    }

    isValidDate(current) {
        return (current.isSameOrBefore(moment()) && current.isSameOrAfter(moment(this.props.oldIssueDate).format("YYYY-MM-DD HH:mm:ss")));
    }

    copy(index) {
        let self = this;
        let documentList = self.state.documentList;
        if (index < documentList.length) {
            let document = documentList[index];
            if (document.inPortal) {
                let params = {
                    url: `/${self.props.controlType}/copyDocument`,
                    method: 'post',
                    data: document
                };
                document.status = "processing";
                document.statusText = "Kopyalama Başlatıldı.";
                documentList[index] = document;
                self.setState({documentList,sendBtnDisabled:true});
                request(params)
                    .then(function (response) {
                        document.status = "success";
                        document.statusText = "Başarılı";
                        documentList[index] = document;
                        self.setState({documentList, index: (index + 1)});
                        self.copy(index + 1);
                    }).catch(function (error) {
                    if (axios.isCancel(error)) {

                    } else {
                        document.status = "error";
                        document.statusText = "Başarısız";
                        documentList[index] = document;
                        self.setState({documentList: documentList});
                        showAxiosError(error);
                        return;
                    }
                    return;
                });
            } else {
                document.status = "error";
                document.statusText = "Başarısız";
                documentList[index] = document;
                self.setState({documentList: documentList});
                self.copy(index + 1);

            }
        } else {
            let listError = 0;
            documentList.forEach((document,index) => {
                if(document.status === "error"){
                    Alert.error(index+1 + '. satırdaki doküman kopyalanamadı.', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    listError = listError+1
                }
            });

            if (listError < documentList.length){
                Alert.warning('Kopyalama tamamlandı.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.props.toggleModal(false,false,true);
            }else {
                self.props.toggleModal(false,false,false);
            }
        }
    }

    getStatusRender(status) {
        let className = (status === "processing" ? "spinner fa-spin" : (status === "success" ? "check" : (status === "error" ? "close" : "pause")));
        let color = (status === "processing" ? "dark" : (status === "success" ? "green" : (status === "error" ? "red" : "dark")));
        return (<i className={"fas fa-" + className} style={{color: color, paddingRight: "4px"}}></i>);
    }

    defineStyleForChangeDateTimeForAll() {

        let durumColumn = document.getElementById('durum');
        let kaynakColumn = document.getElementById('kaynak');
        let paddingR;
        let paddingL;
        if (!!durumColumn) {
            paddingR = durumColumn.offsetWidth;
            paddingL = kaynakColumn.offsetWidth.toString() + 'px';;
            paddingR = paddingR - 6;
            paddingR = paddingR.toString() + 'px';
        } else {
            paddingR = '';
            paddingL = '';
        }
        let padding ={paddingRight: paddingR , paddingLeft: paddingL}
        return this.setState({padding});
    }

    render() {

        return (
            <DefaultModal
                disabled={this.state.sendBtnDisabled}
                isOpen={true}
                title={this.props.title}
                size="lg"
                modalBodyStyle={{padding: "0", minHeight: "500px"}}
                confirmBtnText="Kopyala"
                onConfirm={(e) => this.copy(this.state.index)}
                cancelBtnText="İptal"
                onCancel={this.onCancel}>
                <Col sm="12">
                    <div>
                        <div className="card-body">
                            <p style={{fontWeight: 'bold', margin: '20px 0 0px 0', color: 'chocolate'}}>
                                Sadece portal üzerinde kesilmiş faturalar kopyalanabilir !</p>
                            <Row>
                                <Col sm='6'/>
                                <Col sm='6' style={this.state.padding} title='Tümünün tarihini değiştir' >
                                    <Datetime locale="tr"
                                              input={true}
                                              inputProps={{id: 'issueDateTime'}}
                                              closeOnSelect={false}
                                              closeOnTab={false}
                                              value={moment(this.state.issueDateTime, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(this.state.issueDateTime, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                                  moment(this.state.issueDateTime).format("DD-MM-YYYY HH:mm:ss") :
                                                  this.state.issueDateTime}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat="HH:mm:ss"
                                              isValidDate={function (current) {
                                                  return current.isBefore(Datetime.moment());
                                              }}
                                              onChange={(e) => this.onChangeValueTotal({
                                                  target: {
                                                      name: "cancelTime",
                                                      value: e
                                                  }
                                              })}/>
                                </Col>
                            </Row>
                            <table className=""
                                   style={{textAlign: 'center', paddingBottom: "5px", marginBottom: '25px'}}>
                                <thead>
                                <tr style={{backgroundColor: '#ebedf0'}}>
                                    <th>#</th>
                                    <th>Doküman Numarası</th>
                                    <th>ETTN</th>
                                    <th id='kaynak'>Kaynak</th>
                                    <th>Düzenlenme Tarihi</th>
                                    <th id='durum'>Durum</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.documentList && this.state.documentList.map((document, index) =>
                                    <tr key={index + "_" + document.documentUuid}
                                        style={{backgroundColor: (document.inPortal ? "lightgreen" : "#ffffcc")}}>
                                        <td style={{margin: "0px"}}>{this.state.realIndex + (index + 1)}</td>
                                        <td style={{margin: "0px"}}>{document.documentId}</td>
                                        <td style={{margin: "0px"}}><TextOverFlowTooltip text={document.documentUuid}
                                                                                         maxLength={20}/></td>
                                        <td style={{margin: "0px"}}>{document.inPortal ? "Portal" : "Diğer"}</td>
                                        {document.inPortal &&
                                        <td style={{margin: "0px"}}><Datetime locale="tr"
                                                                              input={true}
                                                                              inputProps={{id: 'issueDateTime'}}
                                                                              closeOnSelect={false}
                                                                              closeOnTab={false}
                                                                              value={
                                                                                  moment(this.state.documentList[index].issuesDate, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(this.state.documentList[index].issuesDate, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                                                                      moment(this.state.documentList[index].issuesDate).format("DD-MM-YYYY HH:mm:ss") :
                                                                                      this.state.documentList[index].issuesDate
                                                                              }
                                                                              dateFormat="DD-MM-YYYY"
                                                                              timeFormat="HH:mm:ss"
                                                                              isValidDate={function (current) {
                                                                                  return current.isBefore(Datetime.moment());
                                                                              }}
                                                                              onChange={(e) => this.onChangeValue({
                                                                                  target: {
                                                                                      name: "cancelTime",
                                                                                      value: e
                                                                                  }
                                                                              }, document, index)}/>
                                        </td>
                                        }
                                        {!document.inPortal &&
                                        <td style={{margin: "0px"}}></td>
                                        }
                                        <td style={{margin: "0px"}}>{this.getStatusRender(document.status)}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            <Row>
                                <Col sm='12'>
                                    <i className="fas fa-square" style={{color: '#10a110'}}/>
                                    <label style={{color: '#10a110', marginLeft: '10px'}}>Yeşille işaretlenmiş
                                        satırlardaki faturalar portal üzerinden kesilmiştir.</label>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>

            </DefaultModal>
        );
    }
}

export default copyModal;